function removeQueries(link: string, removedKeys: string[]): string {
    const parts = link.split('?');
    if (parts.length < 2) {
        return link;
    }
    const queries = parts[1].split('&');
    const query = queries
        .filter((item) => {
        let itemParts = item.split('=');
        return itemParts.length && !removedKeys.includes(itemParts[0]);
    })
        .join('&');
    return query.length ? `${parts[0]}?${query}` : parts[0];
}
export default removeQueries;
